import { useState, useEffect } from 'react';

/**
 * Detecta se o dispositivo é mobile ou desktop
 * @returns {boolean} true se for mobile, false se for desktop/PC
 */
export const isMobileDevice = () => {
    // Verifica pelo user agent
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = /android|webos|iphone|ipod|blackberry|iemobile|opera mini|mobile/i;
    const isMobileUA = mobileKeywords.test(userAgent);

    // Detecção específica para iPad no Safari (que reporta como Macintosh)
    const isIPadSafari = (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1);

    // Verifica pela largura da tela (breakpoint comum para mobile)
    const isMobileWidth = window.innerWidth <= 768;

    // Verifica se é touch device
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Considera mobile se atender a qualquer um dos critérios principais
    return isMobileUA || isIPadSafari || (isMobileWidth && isTouchDevice);
};

/**
 * Hook customizado para detectar dispositivo com atualização em tempo real
 * @returns {boolean} true se for mobile, false se for desktop/PC
 */
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(isMobileDevice());
        };

        // Verifica no carregamento inicial
        checkDevice();

        // Adiciona listener para mudanças de tamanho da tela
        window.addEventListener('resize', checkDevice);

        // Cleanup
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    return isMobile;
};

/**
 * Retorna o layout apropriado baseado no dispositivo
 * @returns {boolean} verticalLayout - false para mobile, true para PC
 */
export const getLayoutByDevice = () => {
    const mobile = isMobileDevice();

    // Se for mobile, verticalLayout=false (layout horizontal)
    // Se for PC, verticalLayout=true (layout vertical)
    return mobile;
};